import React, { Component } from "react"
import clsx from 'clsx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from "prop-types"
import {
  CssBaseline, CircularProgress, Container, Button, Grid, Box, Paper,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Typography, Card, CardContent, Accordion, AccordionSummary, AccordionDetails,
  Chip, TextField, Tooltip, Skeleton
} from "@mui/material"
import { withStyles } from "@mui/styles"
import Pagination from '@mui/material/Pagination'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import moment from "moment"
import { injectIntl } from 'react-intl'
import { Styles } from "../../styles/material-styles"
import CustomizedSnackbars from "../../components/material-snackbars"
import HeaderMenu from "../../components/header-menu"
import Footer from '../../components/footer'
import SimpleDatePicker from '../../components/date-pickers/inline-no-today'
import SimpleAutoComplete from '../../components/auto-complete/autocomplete'
import SimpleAutoCompleteMultiple from '../../components/auto-complete/autocomplete-multiple'
import Api from "../../services/api"
import ApiReports from "../../services/apireport"
import * as calledsActions from '../../redux/actions/calleds'

// Espelha FieldService.Business.Enums.DocumentStatus
const STATUS_OPTIONS = [
  { id: 1, name: 'Pendente', color: '#e0e7ff', textColor: '#3730a3' },
  { id: 2, name: 'Processando', color: '#fef9c3', textColor: '#854d0e' },
  { id: 3, name: 'Processado', color: '#dcfce7', textColor: '#166534' },
  { id: 4, name: 'Falhou', color: '#fee2e2', textColor: '#991b1b' },
  { id: 5, name: 'Parcialmente processado', color: '#ffedd5', textColor: '#9a3412' },
  { id: 6, name: 'Erro', color: '#fee2e2', textColor: '#991b1b' },
  { id: 7, name: 'Aguardando exclusão', color: '#f1f5f9', textColor: '#475569' },
  { id: 8, name: 'Excluído', color: '#f1f5f9', textColor: '#475569' }
]

// Espelha FieldService.Business.Enums.DocumentType
const DOCUMENT_TYPES = {
  1: 'PDF',
  2: 'Texto',
  3: 'Word',
  4: 'Excel',
  5: 'Imagem',
  6: 'Markdown',
  7: 'HTML',
  8: 'CSV'
}

const PAGE_SIZE = 10
const TABLE_COLUMNS = 13

const formatFileSize = (bytes) => {
  if (bytes == null) return '-'
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`
}

const formatDuration = (seconds) => {
  if (seconds == null) return '-'
  const total = Math.max(0, Number(seconds))
  const h = Math.floor(total / 3600)
  const m = Math.floor((total % 3600) / 60)
  const s = Math.floor(total % 60)
  return [h, m, s].map(v => String(v).padStart(2, '0')).join(':')
}

const formatDate = (value) => value ? moment(value).format('DD/MM/YYYY HH:mm:ss') : '-'

class LLMDocumentProcessingReport extends Component {
  constructor(props) {
    super(props)

    this.isAdmGlobal = false

    const { userSession } = this.props

    if (userSession == null || userSession.user == null || userSession.user.userrole == null)
      Api.logoff()

    userSession.user.userrole.map((item) => {
      if (item.role.roletype == 0)
        this.isAdmGlobal = true
    })

    this.state = {
      dateStart: moment().format('YYYY/MM/DD HH:mm:ss'),
      dateEnd: moment().format('YYYY/MM/DD HH:mm:ss'),
      statusFilter: [],
      llmFilter: 0,
      fileNameFilter: '',

      loadingLLMs: false,
      loadingTable: false,
      exporting: false,
      openNotification: false,
      notificationVariant: "error",
      notificationMessage: "",
      showGrid: false,

      documentList: [],
      llmList: [],

      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0
    }

    this.changeValues = this.changeValues.bind(this)
    this.clearFilters = this.clearFilters.bind(this)
  }

  async componentDidMount() {
    this.setState({ loadingLLMs: true })
    await this.getLLMs()
    this.setState({ loadingLLMs: false })
  }

  getLLMs = async () => {
    await Api.get('/llms')
      .then(result => {
        if (result.data.success)
          this.setState({ llmList: result.data.data })
      })
      .catch(() => {})
  }

  changeValues = async (stateName, value) => {
    if (value && value.id !== undefined) {
      this.setState({ [stateName]: value.id })
    } else {
      this.setState({ [stateName]: value })
    }
  }

  clearFilters = () => {
    this.setState({
      dateStart: moment().format('YYYY/MM/DD HH:mm:ss'),
      dateEnd: moment().format('YYYY/MM/DD HH:mm:ss'),
      statusFilter: [],
      llmFilter: 0,
      fileNameFilter: '',
      showGrid: false,
      documentList: [],
      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0
    })
  }

  getDateRange = () => {
    const dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
    const dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')

    if (moment(dateStart).isAfter(moment(dateEnd))) {
      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: "A data inicial deve ser menor que a data final."
      })
      return null
    }

    return { dateStart, dateEnd }
  }

  getSelectedStatusIds = () => (this.state.statusFilter || []).map(s => s.id)

  buildFilterParams = (dateStart, dateEnd) => {
    let params = `startDate=${dateStart}&endDate=${dateEnd}`

    const statusIds = this.getSelectedStatusIds()
    if (statusIds.length > 0)
      params += `&statusIds=${statusIds.join(',')}`

    if (this.state.llmFilter && this.state.llmFilter !== 0)
      params += `&llmId=${this.state.llmFilter}`

    const fileName = (this.state.fileNameFilter || '').trim()
    if (fileName)
      params += `&fileName=${encodeURIComponent(fileName)}`

    return params
  }

  handleSubmit = async (e) => {
    e.preventDefault()

    const range = this.getDateRange()
    if (!range) return

    // A grade aparece já com o skeleton, no lugar do overlay de carregamento.
    this.setState({ showGrid: true, loadingTable: true })
    await this.fetchPaginate(range.dateStart, range.dateEnd, 1)
    this.setState({ loadingTable: false })
  }

  fetchPaginate = async (dateStart, dateEnd, page) => {
    const params = this.buildFilterParams(dateStart, dateEnd)

    await ApiReports.get(`/report/llm-document-processing/paginate?${params}&page=${page}&pageSize=${PAGE_SIZE}`)
      .then(result => {
        if (result.data.success) {
          this.setState({
            documentList: result.data.data,
            count: result.data.count,
            page
          })
          this.setPagination(result.data.count, page)
        }
      })
      .catch(err => {
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage: err.response && err.response.data && err.response.data.errors
            ? err.response.data.errors[0]
            : "Erro ao buscar relatório de processamento de documentos."
        })
      })
  }

  onChangePaginate = (e, page) => {
    this.setState({ loadingTable: true, page })
    const dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
    const dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')
    this.fetchPaginate(dateStart, dateEnd, page).then(() => {
      this.setState({ loadingTable: false })
    })
  }

  setPagination = (count, page) => {
    const totalPage = Math.ceil(count / PAGE_SIZE)
    this.setState({ totalPages: totalPage })
    if (count > 0) {
      const pageStart = ((page - 1) * PAGE_SIZE) + 1
      this.setState({
        pageStart,
        pageEnd: count >= page * PAGE_SIZE ? page * PAGE_SIZE : count
      })
    } else {
      this.setState({ totalPages: 0, page: 1, count: 0, pageStart: 0, pageEnd: 0 })
    }
  }

  closeNotification = () => {
    this.setState({ openNotification: false })
  }

  exportExcel = async () => {
    const range = this.getDateRange()
    if (!range) return

    this.setState({ exporting: true })
    try {

      const fileName = (this.state.fileNameFilter || '').trim()
      const payload = {
        DateStart: range.dateStart,
        DateEnd: range.dateEnd,
        StatusIds: this.getSelectedStatusIds(),
        LLMId: this.state.llmFilter && this.state.llmFilter !== 0 ? this.state.llmFilter : null,
        FileName: fileName || null
      }

      const response = await ApiReports.post('/report/llm-document-processing/excell/new', payload)
      if (response.data && response.data.success) {
        this.setState({
          openNotification: true,
          notificationVariant: "success",
          notificationMessage: this.props.intl.formatMessage({ id: "report.sent" }) + " (" + this.props.userSession.user.email + ")"
        })
      } else {
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage: response && response.data && response.data.errors && response.data.errors[0]
            ? response.data.errors[0]
            : this.props.intl.formatMessage({ id: "process.error" })
        })
      }
    } catch (error) {
      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: error && error.response && error.response.data && error.response.data.errors && error.response.data.errors[0]
          ? error.response.data.errors[0]
          : this.props.intl.formatMessage({ id: "process.error" })
      })
    }
    this.setState({ exporting: false })
  }

  renderStatusChip(status) {
    const option = STATUS_OPTIONS.find(s => s.id === status)
    if (!option)
      return <Chip size="small" label={status} />

    return (
      <Chip
        size="small"
        label={option.name}
        style={{ backgroundColor: option.color, color: option.textColor, fontWeight: 600 }} />
    )
  }

  renderSkeletonRows() {
    return Array.from({ length: PAGE_SIZE }).map((_, rowIdx) => (
      <TableRow key={`skeleton-${rowIdx}`} style={{ backgroundColor: rowIdx % 2 === 0 ? '#fff' : '#f8fafc' }}>
        {Array.from({ length: TABLE_COLUMNS }).map((__, colIdx) => (
          <TableCell key={colIdx}>
            <Skeleton variant="text" animation="wave" />
          </TableCell>
        ))}
      </TableRow>
    ))
  }

  renderMainTable() {
    const { documentList, loadingTable } = this.state
    const headerStyle = { fontWeight: 700, color: '#fff', whiteSpace: 'nowrap' }

    return (
      <Paper elevation={2} style={{ borderRadius: 12, overflow: 'hidden', marginBottom: 20 }}>
        <Box style={{ padding: '16px 20px', backgroundColor: '#3F51B4', color: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="subtitle1" style={{ fontWeight: 600, color: 'inherit' }}>
            Documentos processados
          </Typography>
          <Typography variant="caption" style={{ opacity: 0.8, color: 'inherit' }}>
            {this.state.loadingTable
              ? <Skeleton variant="text" animation="wave" width={80} style={{ backgroundColor: 'rgba(255,255,255,0.3)' }} />
              : `${this.state.count} registro(s)`}
          </Typography>
        </Box>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow style={{ backgroundColor: '#3F51B4' }}>
                <TableCell style={headerStyle}>Arquivo</TableCell>
                <TableCell style={headerStyle}>LLM</TableCell>
                <TableCell style={headerStyle}>Tipo</TableCell>
                <TableCell style={headerStyle} align="right">Tamanho</TableCell>
                <TableCell style={headerStyle}>Status</TableCell>
                <TableCell style={headerStyle}>Criado em</TableCell>
                <TableCell style={headerStyle}>Início</TableCell>
                <TableCell style={headerStyle}>Fim</TableCell>
                <TableCell style={headerStyle} align="right">Duração</TableCell>
                <TableCell style={headerStyle} align="right">Tentativas</TableCell>
                <TableCell style={headerStyle} align="right">Chunks</TableCell>
                <TableCell style={headerStyle}>Host</TableCell>
                <TableCell style={headerStyle}>Erro</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loadingTable ? this.renderSkeletonRows() : documentList.map((item, idx) => (
                <TableRow
                  key={item.id}
                  hover
                  style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#f8fafc' }}>
                  <TableCell style={{ maxWidth: 260, wordBreak: 'break-all' }}>{item.originalfilename || '-'}</TableCell>
                  <TableCell>{item.llmname || '-'}</TableCell>
                  <TableCell>{DOCUMENT_TYPES[item.documenttype] || item.documenttype || '-'}</TableCell>
                  <TableCell align="right" style={{ whiteSpace: 'nowrap' }}>{formatFileSize(item.filesizebytes)}</TableCell>
                  <TableCell>{this.renderStatusChip(item.status)}</TableCell>
                  <TableCell style={{ whiteSpace: 'nowrap' }}>{formatDate(item.createdat)}</TableCell>
                  <TableCell style={{ whiteSpace: 'nowrap' }}>{formatDate(item.processingstartedat)}</TableCell>
                  <TableCell style={{ whiteSpace: 'nowrap' }}>{formatDate(item.processingcompletedat)}</TableCell>
                  <TableCell align="right" style={{ fontFamily: 'monospace' }}>{formatDuration(item.durationseconds)}</TableCell>
                  <TableCell align="right">{item.processingattempt}</TableCell>
                  <TableCell align="right" style={{ whiteSpace: 'nowrap' }}>{item.processedchunks} / {item.totalchunks}</TableCell>
                  <TableCell style={{ fontFamily: 'monospace' }}>{item.processinghostid || '-'}</TableCell>
                  <TableCell style={{ maxWidth: 280 }}>
                    {item.processingerror
                      ? (
                        <Tooltip title={item.processingerror}>
                          <Typography variant="body2" noWrap style={{ color: '#991b1b', maxWidth: 280 }}>
                            {item.processingerror}
                          </Typography>
                        </Tooltip>
                      )
                      : '-'}
                  </TableCell>
                </TableRow>
              ))}
              {!loadingTable && documentList.length === 0 && (
                <TableRow>
                  <TableCell colSpan={TABLE_COLUMNS} align="center" style={{ padding: 40, color: '#94a3b8' }}>
                    Nenhum documento encontrado no período informado.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    )
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props

    if (!this.isAdmGlobal) {
      const l = this.props.match.params.lang
      document.location.href = `/${l}/unavailable`
    }

    if (Api == null) {
      const l = this.props.match.params.lang
      document.location.href = `/${l}/unavailable`
    }

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}>
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
            <CssBaseline />

            <Grid container spacing={6}>
              <Grid item xs={12} sm={12}>
                <Card>
                  <CardContent className="background-title-search">
                    <Typography variant="h5">
                      Relatório de Processamento de Documentos de LLM
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            <form name='llmDocumentProcessingReportForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'>
              <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className={classes.heading}>Filtros</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container style={{ marginBottom: 20 }} spacing={2}>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleDatePicker
                        label="Data Inicial"
                        name='dateStart'
                        stateName='dateStart'
                        changeDate={this.changeValues}
                        currentDate={this.state.dateStart}
                        fullWidth={true}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleDatePicker
                        label="Data Final"
                        name='dateEnd'
                        stateName='dateEnd'
                        changeDate={this.changeValues}
                        currentDate={this.state.dateEnd}
                        fullWidth={true}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleAutoCompleteMultiple
                        label="Status"
                        options={STATUS_OPTIONS}
                        stateName='statusFilter'
                        changeSelect={this.changeValues}
                        selected={this.state.statusFilter}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      {this.state.loadingLLMs
                        ? <Skeleton variant="rectangular" animation="wave" height={56} style={{ borderRadius: 4 }} />
                        : (
                          <SimpleAutoComplete
                            label="LLM"
                            options={this.state.llmList}
                            stateName='llmFilter'
                            changeSelect={this.changeValues}
                            selected={this.state.llmList.find(item => item.id === this.state.llmFilter) || { id: 0, name: '' }}
                          />
                        )}
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <TextField
                        label="Nome do arquivo"
                        name='fileNameFilter'
                        value={this.state.fileNameFilter}
                        onChange={(e) => this.setState({ fileNameFilter: e.target.value })}
                        InputLabelProps={{ shrink: true }}
                        placeholder="Contém..."
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Grid container style={{ marginBottom: 10 }}>
                <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                  <Button type='submit' fullWidth variant='contained' color='secondary' disabled={this.state.loadingTable}>
                    Filtrar
                  </Button>
                </Grid>
                <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                  <Button fullWidth variant='contained' color='secondary' onClick={this.clearFilters}>
                    Limpar filtros
                  </Button>
                </Grid>
                {this.state.showGrid && (
                  <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                    <Button
                      fullWidth
                      variant='contained'
                      color='secondary'
                      onClick={this.exportExcel}
                      disabled={this.state.exporting || this.state.loadingTable}
                      startIcon={this.state.exporting ? <CircularProgress size={16} color="inherit" /> : null}>
                      {this.state.exporting ? 'Solicitando...' : 'Exportar Excel'}
                    </Button>
                  </Grid>
                )}
              </Grid>
            </form>

            {this.state.showGrid && (
              <>
                <Box style={{ marginTop: 32 }}>
                  {this.renderMainTable()}
                </Box>

                <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                  <Grid item xs={12} md={3}>
                    <Pagination count={this.state.totalPages} page={this.state.page} onChange={this.onChangePaginate} disabled={this.state.loadingTable} />
                  </Grid>
                  <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                    {this.state.loadingTable
                      ? <Skeleton variant="text" animation="wave" width={160} />
                      : `${this.state.pageStart} a ${this.state.pageEnd} de ${this.state.count} registro(s)`}
                  </Grid>
                </Grid>
              </>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification} />
          </Container>
        </main>
        <Footer />
      </div>
    )
  }
}

LLMDocumentProcessingReport.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(calledsActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(LLMDocumentProcessingReport)))
